<!-- <select >
<option *ngFor="let item of items" [ngValue]="item.value">
  {{ item.description }}
</option>
</select> -->
<!-- <ellf-select
[formControl]="operatorControl"
[items]="items"
[clearable]="false"
>
</ellf-select> -->
@if (!readOnly) {
  <div ngbDropdown class="d-inline-block" container="body">
    <button type="button" class="btn text-primary selected p-0" ngbDropdownToggle>
      {{ selectedItem?.description }}
    </button>
    <div ngbDropdownMenu class="operators">
      @for (item of items; track item) {
        <button
          type="button"
          ngbDropdownItem
          (click)="setOperator(item)"
          >
          {{ item.description }}
        </button>
      }
    </div>
  </div>
}
@if (readOnly) {
  <div class="text-primary selected">
    {{ selectedItem?.description }}
  </div>
}
